import {
  ListGroup, Row, Col, Form
} from "react-bootstrap";
import IMFAOption from "interfaces/IMFAOption";

interface MFAOptionItemProps {
  mfaOption: IMFAOption;
  register: any;
}

const MFAOptionItem = ({ mfaOption, register } : MFAOptionItemProps) => (
  <ListGroup.Item>
    <Form.Group>
      <Row className="align-items-center mfa-option-item">
        <Col xs={11}>
          <Form.Label htmlFor={`mfaOption_${mfaOption.id}`} className={`${mfaOption.disabled ? "disabled" : ""}`}>
            <p className="heading" data-testid={`mfaOptionHeading_${mfaOption.id}`}>{mfaOption.heading}</p>
            <p className="sub-heading" data-testid={`mfaOptionSubHeading_${mfaOption.id}`}>{mfaOption.subHeading}</p>
          </Form.Label>
        </Col>
        <Col xs={1}>
          <Form.Check
            data-testid={`mfaOption_${mfaOption.id}`}
            {...register("mfaOption")}
            type="radio"
            name="mfaOption"
            value={`${mfaOption.id}`}
            id={`mfaOption_${mfaOption.id}`}
            disabled={mfaOption.disabled}
          />
        </Col>
      </Row>
    </Form.Group>
  </ListGroup.Item>

);

export default MFAOptionItem;
